import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export default class Valueprop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            page: "travelers",
            step: 1
        };

        this.setPage = this.setPage.bind(this);
        this.setStep = this.setStep.bind(this);
    }

    componentDidMount() {
    }


    componentWillUnmount() {
    }


    setPage(page) {
        this.setState({
            page: page,
            step: 1
        });
    }


    setStep(step) {
        this.setState({
            step: step
        });
    }


    render() {

        return (
            <div className="home__howitworks-container">
                <h2 className="home__howitworks__title text-title">
                    How it works
                </h2>
                <div className="home__howitworks-wrapper">
                    <div className="home__howitworks__buttonbox">
                        <div onClick={() => this.setPage("travelers")} className={"button home__howitworks__buttonbox__button home__howitworks__buttonbox__button-travelers" + (this.state.page === "travelers" ? " home__howitworks__buttonbox__button--active" : "")}>
                            For travelers
                        </div>
                        <div onClick={() => this.setPage("creators")} className={"button home__howitworks__buttonbox__button home__howitworks__buttonbox__button-creators" + (this.state.page === "creators" ? " home__howitworks__buttonbox__button--active" : "")}>
                            For itinerary creators
                        </div>
                    </div>

                    {this.state.page == "travelers" &&
                        <div className="home__howitworks__stepbox">
                            <div className="home__howitworks__stepbox__step--empty"></div>
                            <div onClick={() => this.setStep(1)} className={"home__howitworks__stepbox__step home__howitworks__stepbox__step-1" + (this.state.step === 1 ? " home__howitworks__stepbox__step--active" : "")}>
                                1. Explore trips
                            </div>
                            <div onClick={() => this.setStep(2)} className={"home__howitworks__stepbox__step home__howitworks__stepbox__step-2" + (this.state.step === 2 ? " home__howitworks__stepbox__step--active" : "")}>
                                2. Choose itineraries
                            </div>
                            <div onClick={() => this.setStep(3)} className={"home__howitworks__stepbox__step home__howitworks__stepbox__step-3" + (this.state.step === 3 ? " home__howitworks__stepbox__step--active" : "")}>
                                3. Get instant access
                            </div>
                            <div className="home__howitworks__stepbox__step--empty"></div>
                        </div>
                    }

                    {this.state.page == "creators" &&
                        <div className="home__howitworks__stepbox">
                            <div className="home__howitworks__stepbox__step--empty"></div>
                            <div onClick={() => this.setStep(1)} className={"home__howitworks__stepbox__step home__howitworks__stepbox__step-1" + (this.state.step === 1 ? " home__howitworks__stepbox__step--active" : "")}>
                                1. Create and share
                            </div>
                            <div onClick={() => this.setStep(2)} className={"home__howitworks__stepbox__step home__howitworks__stepbox__step-2" + (this.state.step === 2 ? " home__howitworks__stepbox__step--active" : "")}>
                                2. Market your itineraries
                            </div>
                            <div onClick={() => this.setStep(3)} className={"home__howitworks__stepbox__step home__howitworks__stepbox__step-3" + (this.state.step === 3 ? " home__howitworks__stepbox__step--active" : "")}>
                                3. Earn and engage
                            </div>
                            <div className="home__howitworks__stepbox__step--empty"></div>
                        </div>
                    }

                    <div className="home__howitworks__content">

                        {this.state.page == "travelers" && this.state.step == 1 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🗺️ Browse itineraries</span> by destination, season, interests, or budget and use filters to refine your search.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🌍 Explore trending destinations</span> and travel experts.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">👥 See what other itineraries</span> your favorite travel experts have to offer.
                                </p>
                            </div>
                        }

                        {this.state.page == "travelers" && this.state.step == 2 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🆓 Access free itineraries</span> instantly or purchase exclusive, expert-crafted itineraries for detailed insights.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🔗 Connect with travel experts</span> on different platforms to see if they match your vibe.
                                </p>
                            </div>
                        }

                        {this.state.page == "travelers" && this.state.step == 3 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🗂️ View your ready-to-go itinerary</span> online with maps, tips, and recommendations.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">💬 Connect with travel experts</span> to clarify your questions or fine-tune your itinerary.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🛤️ Follow step-by-step guidance</span> for a seamless travel experience.
                                </p>
                            </div>
                        }

                        {this.state.page == "creators" && this.state.step == 1 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">✍️ Build detailed itineraries</span> with activities, locations, and recommendations.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">💡 Add tips, hidden gems</span>, and personal insights.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">💰 Set a price</span> or offer itineraries for free to your community.
                                </p>
                            </div>
                        }

                        {this.state.page == "creators" && this.state.step == 2 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">📢 Market your itineraries</span> to your community through social media.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🔗 Redirect your community</span> to your Guidr trip page.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🚀 Gain additional exposure</span> to travelers looking for itineraries on Guidr.
                                </p>
                            </div>
                        }

                        {this.state.page == "creators" && this.state.step == 3 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">💵 Get paid</span> when travelers purchase your itinerary.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🤝 Interact with travelers</span> through Q&A or personalized tips.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">📈 Continue to grow your community</span> across platforms while managing your itineraries with Guidr.
                                </p>
                            </div>
                        }


                        {/* <div className="home__howitworks__content__video">
                            Video
                        </div> */}
                    </div>

                    <div className="home__howitworks__cta-container">
                        {this.state.page == "travelers" &&
                            <Link to={"/travelers"} className="button button-secondary">
                                Learn more
                            </Link>
                        }
                        {this.state.page == "creators" &&
                            <Link to={"/creators"} className="button button-secondary">
                                Learn more
                            </Link>
                        }
                    </div>

                </div>
            </div>
        )
    }
}
